import React, { useState, useCallback, Fragment, useEffect } from 'react';
import { useNotify } from 'react-admin';
import { Button, Box, Grid, Paper, CircularProgress, TextField, Typography, Divider } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import UpdateIcon from '@mui/icons-material/Update';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { ruleList } from './RuleStatic';
import client from '../common/client';

const sx = {
    root: {
        display: 'flex',
        alignItems: 'center'
    }
}

const ConfirmDialog = props => {

}

const RuleList = props => {
    const notify = useNotify();
    const [loading, setLoading] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [rows, setRows] = useState([{}]);

    const handleChange = (event) => {

    }

    const handleOnChange = (e, aaa) => {
        //alert(aaa)

    }

    useEffect(() => {

    })

    const handleEdit = (event, row) => {
        if (props.edit)
            props.edit(row)
    };

    const handleRemove = (event, row) => {
        if (window.confirm('Do you want to remove the rule?')) {
            setLoadingDelete(true)
            client.request_get(`/api/rule/remove/${row.id}`).then(res => {
                setLoadingDelete(false)
                if (res.r) {
                    notify('Rule Removed')
                    if (props.changed)
                        props.changed()
                } else
                    notify(res.msg, 'error')

            }).catch(e => {
                setLoadingDelete(false)
                notify(e)
            })
        }
    };


    return (
        <Fragment>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Rule Type</TableCell>
                            <TableCell>Node</TableCell>
                            <TableCell>Value</TableCell>
                            <TableCell>Update Date</TableCell>
                            <TableCell>Error</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.list && props.list.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell component="th" scope="row">
                                    {ruleList.filter(m => m.type == row.type).length > 0 ?
                                        ruleList.filter(m => m.type == row.type)[0].icon()
                                        : row.type}
                                </TableCell>
                                <TableCell>
                                    {row.node}
                                </TableCell>
                                <TableCell>
                                    {row.value}
                                </TableCell>
                                <TableCell>
                                    {row.reg_date}
                                </TableCell>
                                <TableCell>
                                    <Typography component="h2" color="error">
                                        {row.err}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Button variant="outlined" color="primary"
                                        startIcon={<EditIcon />}
                                        onClick={(e) => handleEdit(e, row)}>Edit</Button>
                                    &nbsp;
                                    <Button variant="outlined" color="primary"
                                        startIcon={loadingDelete ? <CircularProgress size={20} /> : <DeleteOutlineIcon />}
                                        disabled={loadingDelete}
                                        onClick={(e) => handleRemove(e, row)}>Remove</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Fragment>
    );
};

export default RuleList;
